import React, { useEffect } from 'react';
import { ProjectAccessProvider } from '../../../context/projectAccess/ProjectAccessContext';
import ProjectActionMenu, {
  ProjectActionMenuVariant,
} from '../../Cards/project/ProjectActionMenu';
import { UserProjectQuery } from '../../Projects/operation.generated';
import { ProjectCardOriginPage } from '../../Cards/project/ProjectCard';
import { useAppDispatch } from '../../../store/hooks';
import { setCurrentDrive } from '../../../store/DrivesSlice';
import StudioBreadcrumbs from './StudioBreadcrumbs';

interface StudioProjectNavbarProps {
  project: NonNullable<UserProjectQuery['user']['project']>;
  showActions?: boolean;
}

function StudioProjectNavbarToolbar({
  project,
}: {
  project: NonNullable<UserProjectQuery['user']['project']>;
}) {
  return (
    <ProjectActionMenu
      variant={ProjectActionMenuVariant.StudioNavBar}
      project={project}
      currentDriveId={project.rootDriveId || undefined}
      currentFolderId={project.folderId || undefined}
      isSharedDrive={!project.rootDriveId}
      disableSelect
      pageOrigin={ProjectCardOriginPage.StudioNavbar}
    />
  );
}

const StudioProjectNavbar = ({
  project,
  showActions = true,
}: StudioProjectNavbarProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (project?.driveId) {
      dispatch(setCurrentDrive({ driveId: project.driveId }));
    }
  }, [dispatch, project?.driveId]);

  return (
    <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
      <StudioBreadcrumbs project={project} />
      {showActions && (
        <div
          style={{
            marginLeft: 4,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <ProjectAccessProvider
            ability={
              (project.projectAccess.viewerAccessRole?.permissions as string) ||
              JSON.stringify({ A: [] })
            }
          >
            <StudioProjectNavbarToolbar project={project} />
          </ProjectAccessProvider>
        </div>
      )}
    </div>
  );
};

export default StudioProjectNavbar;
